module.exports = __webpack_public_path__ + "media/images/tpl/pages-537457b3f08dd1b91ecf3f9b4ee72612.svg";